import { userModel } from 'APP/model/model';
import { IGetUsersByEmailsParams } from 'APP/model/user/userModel.types';
import Entities from 'STORE';
import { User } from 'STORE/Users/User/User';

export const getUsersByEmails = async (params: IGetUsersByEmailsParams): Promise<User[]> => {
  try {
    const users = await userModel.getUsersByEmails(params);

    return users.map((user) => new User(Entities.usersStore, user));
  } catch {
    return [];
  }
};
